import { render, staticRenderFns } from "./siteSetting.vue?vue&type=template&id=f0bbc30a&scoped=true"
import script from "./siteSetting.vue?vue&type=script&lang=js"
export * from "./siteSetting.vue?vue&type=script&lang=js"
import style0 from "./siteSetting.vue?vue&type=style&index=0&id=f0bbc30a&prod&lang=css"
import style1 from "./siteSetting.vue?vue&type=style&index=1&id=f0bbc30a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bbc30a",
  null
  
)

export default component.exports